import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { IMAGES, scrollToSection } from '../lib/constants';

export const HeroSection = () => {
  return (
    <section
      data-testid="hero-section"
      className="relative h-[90vh] min-h-[600px] flex items-center justify-center overflow-hidden -mt-20"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={IMAGES.heroPool}
          alt="HDH Pools Southern Utah"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F1D32]/70 via-[#0F1D32]/50 to-[#0F1D32]/80" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
        <p className="animate-fade-in text-amber-400 font-body text-sm font-semibold uppercase tracking-[0.25em] mb-6">
          Southern Utah Pool Builder
        </p>

        <h1 className="animate-slide-up font-heading text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-700 text-white leading-[1.05] tracking-tight italic">
          Custom Pools.
          <br />
          Clear Process.
        </h1>

        <p className="animate-fade-in-up animate-delay-300 mt-8 text-lg md:text-xl text-white/70 font-body leading-relaxed max-w-2xl mx-auto">
          Pool construction backed by organized operations, transparent
          communication, and craftsmanship you can see at every stage.
        </p>

        <div className="animate-fade-in-up animate-delay-500 flex flex-col sm:flex-row gap-4 justify-center mt-12">
          <Button
            size="lg"
            data-testid="hero-cta-request-quote"
            onClick={() => scrollToSection('quote')}
            className="bg-amber-500 hover:bg-amber-600 text-white font-bold text-sm uppercase tracking-wider px-10 py-6 rounded-sm"
          >
            Request a Quote
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="lg"
            data-testid="hero-cta-see-process"
            onClick={() => scrollToSection('gallery')}
            className="border-2 border-white/30 text-white hover:bg-white/10 hover:border-white/50 font-semibold text-sm uppercase tracking-wider px-10 py-6 rounded-sm"
          >
            View Our Work
          </Button>
        </div>
      </div>

      {/* Bottom gradient fade */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent z-10" />
    </section>
  );
};
